export default __webpack_public_path__ + "static/media/eleven.6cede2c5.jpg";